import { useParams } from 'react-router';
import { useForm } from 'react-hook-form';
import React, { useEffect, useState } from 'react';

import { useApi } from '../../util/lib';
import Button from '../UI/Buttons/Button';
import SuccessBanner from './SuccessBanner';
import { delay } from '../../util/ExtraMethods';
import css from './NotificationUnsubs.module.css';
import NotificationCard from './NotificationCard';
import { useUnsubscribe } from '../../hooks/useUnsubscribe';

// Notification preferences
export const UnsubNotifScope = {
  // Order here determines the order of the preferences in the UI
  BookingReminder: 'booking-reminder',
  ServiceReminder: 'service-reminder',
  Reviews: 'reviews',
  Campaigns: 'campaigns',
  // Booking: 'booking',
  // Quotes: 'quotes',
  // Account: 'account',
};

export const NotificationPreferenceLabels = {
  // [UnsubNotifScope.Account]: 'Account',
  [UnsubNotifScope.BookingReminder]: 'Appointment reminders',
  [UnsubNotifScope.ServiceReminder]: 'Service due',
  [UnsubNotifScope.Reviews]: 'Review requests',
  [UnsubNotifScope.Campaigns]: 'Campaigns & promotions',
};

const allScopes = Object.values(UnsubNotifScope);
const scopes = allScopes.map((scope) => [scope, NotificationPreferenceLabels[scope]]);

const NotificationUnsubs = () => {
  const api = useApi();
  const {id} = useParams();
  const [selected, setSelected] = useState([]);
  const [submitting, setSubmitting] = useState();
  const [showSuccess, setShowSuccess] = useState(false);

  const { unsubscribe } = useUnsubscribe(id);

  const form = useForm({
    defaultValues: {
      emailAll: null,
      emailScopes: [],
    }
  });

  const onChange = (e) => {
    const value = e.target.value + '';
    const isChecked = !!e.target.checked;
    let newSelected;
    if (isChecked) {
      newSelected = selected.filter(item => item !== value);
      console.log('onChange all reset', value);
      form.setValue('all', null);
    } else {
      newSelected = [...selected, value];
      console.log('onChange', {value, isChecked});
    }
    setSelected(newSelected);
  }
  const onChangeAll = (state) => {
    const isAll = !!state;
    console.log('onChangeAll', isAll);
    setSelected(
      isAll ? scopes.map(scope => scope[0]) : []
    );
  }
  const onSubmit = form.handleSubmit(async (rawData) => {
    try {
      if (submitting) return;
      setSubmitting(true);
      await delay(100);
      if (showSuccess)
        setShowSuccess(false);

      const data = { ...rawData };
      let scopePayload = [];
      const disabledScopes = allScopes.filter((scope) => !data?.emailScopes?.includes(scope));
      const existingScopeMap = {};
      (unsubscribe?.emailScopes || [])
        .filter((item) => disabledScopes.includes(item?.scope))
        .forEach((item) => {
          existingScopeMap[item.scope] = {
            scope: item.scope,
            customerInitiated: item.customerInitiated,
          };
        });
      const determineCustomerInitiated = (scope) => {
        const old = existingScopeMap?.[scope]?.customerInitiated;
        if (old !== null && old !== undefined) return old;
        return true;
      };
      scopePayload = disabledScopes.map((scope) => ({
        scope,
        customerInitiated: determineCustomerInitiated(scope),
      }));
      const payload = {
        ...data,
        emailScopes: scopePayload,
      }
      if (payload.emailScopes?.length === allScopes.length) {
        payload.emailAll = true;
      } else {
        payload.emailAll = false;
      }
      console.log('onSubmit', data);
      const response = await api({
        data: payload,
        method: 'put',
        responseType: 'json',
        url: `/customers/${id}/unsubscribe`,
      });
      console.log('response', response);
      if (!response.data.success) {
        throw new Error('Failed to unsubscribe');
      }
      setShowSuccess(true);
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
      console.error(error);
    }
  });

  useEffect(() => {
    if (!unsubscribe?.emailScopes || !unsubscribe?.emailScopes?.length) {
      setSelected([]);
      return;
    };
    const selectedScopes = unsubscribe.emailScopes
      .map((item) => item?.scope)
      .filter(Boolean);
    setSelected(selectedScopes);
  }, [unsubscribe, setSelected]);

  return (
    <div className={css.Container}>
      <SuccessBanner
        show={showSuccess}
        onDismiss={() => setShowSuccess(false)}
        title="Your notification preferences were saved"
        message="We'll send you email updates only for the notification types you selected below. You can change these settings anytime."
      />
      <h2>Repairy Notifications</h2>
      <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
        <p>
          Choose which Repairy notifications you want to receive by email.
        </p>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
          <p>SELECT:</p>
          <p style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => onChangeAll(false)}>ALL</p>
          <p style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => onChangeAll(true)}>NONE</p>
        </div>
      </div>
      <div className={css.Grid}>
        {scopes.map((scope, idx) => {
          const fieldId = `form_scope_${scope[0]}_${idx}`;
          return (
            <NotificationCard
              key={scope[0]}
              inputId={fieldId}
              label={scope[1]}
              value={scope[0]}
              onScopeChange={onChange}
              registerInput={form.register('emailScopes')}
              checked={!selected.some((value) => value === scope[0])}
            />
          );
        })}
      </div>
      <Button
        type='main'
        onClick={onSubmit}
        disabled={submitting}
        css={[
          css.Submit,
          submitting && css.SubmitDisabled,
        ].join(' ')}>
        {submitting ? 'Submitting...' : 'Submit'}
      </Button>
    </div>
  )
}
export default NotificationUnsubs;
